export const tokens = {
    action: {
        gap: 8,
        padding: 10,
        height: 28,
    },
    label: {
        size: 13,
    },
    icon: {
        size: 10,
    },
    badge: {
        padding: 6,
        size: 20,
        fontSize: 10,
    },
};
